import { render, staticRenderFns } from "./QueueManagement.vue?vue&type=template&id=2055f109&"
import script from "./QueueManagement.vue?vue&type=script&lang=js&"
export * from "./QueueManagement.vue?vue&type=script&lang=js&"
import style0 from "./QueueManagement.vue?vue&type=style&index=0&id=2055f109&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports